import { render, staticRenderFns } from "./daixiang.vue?vue&type=template&id=6900410b&scoped=true&"
import script from "./daixiang.vue?vue&type=script&lang=js&"
export * from "./daixiang.vue?vue&type=script&lang=js&"
import style0 from "./daixiang.vue?vue&type=style&index=0&id=6900410b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6900410b",
  null
  
)

export default component.exports